<template>
  <SimplePage title="顧客情報ダウンロード" storeNameFull :storeSelectable="isTokenAlive" :loading="busy" noIcon>
    <template #main>
      <Error v-if="!isTokenAlive" :header="false" hideLogin>
        <template #description>
          <p class="small-text description">
            期限が切れたため顧客情報のダウンロードはできません。
            再度ダウンロードを行いたい場合は、ぐるなび担当営業、もしくはカスタマーサポートサービスまでお問い合わせください。
          </p>
        </template>
      </Error>
      <div v-else class="main">
        <p class="title">
          顧客情報のダウンロードが行えます。情報量によってはダウンロード完了までにお時間がかかる場合がございます。
        </p>
        <PropertySection
          class="section"
          title="すべての顧客情報をダウンロード"
          button="ダウンロード"
          @click="download(0)"
          :disabled="busy"
          small
          primary
        >
          <template #text>
            <div class="text">
              <p>
                ログインしているアカウントで閲覧可能な店舗の初期登録した顧客情報・来店履歴がある顧客情報がダウンロードできます。
              </p>
              <p>同一顧客が複数の店舗に来店していた場合は来店履歴に店舗名が表示されます。</p>
            </div>
          </template>
        </PropertySection>
        <PropertySection
          class="section"
          title="初期登録された顧客情報をダウンロード"
          button="ダウンロード"
          @click="download(!!displayPattern ? 3 : 1)"
          :disabled="busy"
          small
          primary
        >
          <template #text>
            <div class="text">
              <p>ログインしている店舗で初期登録された顧客情報がダウンロードできます。</p>
              <p>他店で初期登録された顧客情報に来店履歴がある場合は表示されませんのでご注意ください。</p>
            </div>
          </template>
        </PropertySection>
        <PropertySection
          v-if="displayPattern"
          class="section"
          title="すべての来店履歴をダウンロード"
          button="ダウンロード"
          @click="download(4)"
          :disabled="busy"
          small
          primary
        >
          <template #text>
            <div class="text">
              <p>
                ログインしているアカウントが閲覧可能な店舗で、1回以上の来店回数がある顧客の来店履歴がダウンロードできます。
              </p>
              <p>顧客1人につき複数行の来店履歴が出力されます。</p>
            </div>
          </template>
        </PropertySection>
        <PropertySection
          v-if="displayPattern"
          class="section"
          title="現在選択されている店舗で、来店履歴のある顧客情報のみの来店履歴をダウンロード"
          button="ダウンロード"
          @click="download(2)"
          :disabled="busy"
          small
          primary
        >
          <template #text>
            <div class="text">
              <p>現在選択されている店舗で、1回以上の来店回数がある顧客の来店履歴がダウンロードできます。</p>
              <p>顧客1人につき複数行の来店履歴が出力されます</p>
            </div>
          </template>
        </PropertySection>
      </div>
    </template>
  </SimplePage>
</template>

<script>
import { mapState } from 'vuex'
import SimplePage from '@/components/templates/SimplePage'
import PropertySection from '@/components/molecules/PropertySection'
import Error from '@/views/Error'

export default {
  name: 'CustomerCsvDownload',
  components: {
    SimplePage,
    PropertySection,
    Error,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      isTokenAlive: state => state.stores.current.store.isTokenAlive,
      displayPattern: state => state.stores.current.store.displayPattern,
      csvData: state => state.customers.csv.data,
      busy: state => state.customers.csv.busy,
    }),
  },
  methods: {
    async download(range) {
      if (await this.$store.dispatch('customers/csv/download', range)) {
        if (STAGE === STAGE_LOCAL) {
          // ローカル用
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob(['Hello'], { type: 'text/plain' }))
          link.download = 'sample.xlsx'
          link.click()
        } else {
          const disposition = this.csvData.getResponseHeader('Content-Disposition')
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          const matches = filenameRegex.exec(disposition)

          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(this.csvData.response)
          link.download = decodeURI(matches[1].replace(/['"]/g, ''))
          link.click()
        }
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.main {
  display: grid;
  grid-gap: 32px;
  padding: 32px;
}

.section {
  >>> .button {
    width: 124px;
  }
}

.text {
  font-size: 13px;
  line-height: 20px;
}
</style>
